module.exports = __webpack_public_path__ + "img/tree.7ec240a2.png";